import { render, staticRenderFns } from "./ExperienceCategoryCreate.vue?vue&type=template&id=c80986e8&scoped=true"
import script from "./ExperienceCategoryCreate.vue?vue&type=script&lang=js"
export * from "./ExperienceCategoryCreate.vue?vue&type=script&lang=js"
import style0 from "./ExperienceCategoryCreate.vue?vue&type=style&index=0&id=c80986e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80986e8",
  null
  
)

export default component.exports